import { loadable } from 'utils';

export const Import = loadable(() => import('./Import'), {});
